module.exports = __webpack_public_path__ + "static/media/dentalbraces.398657d3.png";